import { useEffect, useCallback } from 'react';

const handleBeforeUnload = (event) => {
  event.preventDefault();
  event.returnValue = '';
};

export default function useReloadAlert(shouldBlock = true) {
  useEffect(() => {
    if (!shouldBlock) return;

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [shouldBlock]);

  const disableAlert = useCallback(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return disableAlert;
}
